'use strict';


export default function() {
	return {
		transclude: true,
		template: '<div anti-expansion><div ng-transclude class="action-box-body"></div></div>',
	}
}
